import { API_BASE_URL } from '../config';

export interface PriceItem {
    symbol: string;
    date: string;
    price: number;
    name: string,
    exchange: string
}
  export const fetchLastPrice = async (): Promise<PriceItem[]> => {
    const API_URL = `${API_BASE_URL}/latest-price`; // Replace with your real endpoint
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as PriceItem[]; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
  };

  export const fetchLastPriceBySymbol = async (symbol: string): Promise<PriceItem> => {
    var API_URL = `${API_BASE_URL}/symbol/${symbol}`; // Replace with your real endpoint
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as PriceItem; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
  }